import { forwardRef, useState } from 'react';
import { outlineGray } from '../../config/colors';
import { ErrorMsg, InputAndErrorWrapper } from './styles';

const ValidationInput = forwardRef((props, ref) => {
  const [isValid, setIsValid] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  const InputElement = props.component;
  const onChangeFunc = props.onChange;
  const validationFunc = props.validation;

  const showError = !isValid && isDirty;
  return (
    <InputAndErrorWrapper style={props.containerStyle}>
      <InputElement
        {...props}
        style={{
          borderColor: showError ? 'red' : outlineGray,
          outlineColor: showError ? 'red' : 'royalBlue',
          width: '100%',
          height: '100%',
        }}
        onChange={(event) => {
          !isDirty && setIsDirty(true);
          if (validationFunc) {
            // temporary fix, change event.target.name with more suitable field name
            setIsValid(validationFunc(event.target.name, event.target.value));
          }
          onChangeFunc(event);
        }}
        onFocus={(event) => {
          if (validationFunc) {
            setIsValid(validationFunc(event.target.name, event.target.value));
          }
        }}
        ref={ref}
      />
      {showError && <ErrorMsg>{props.errorMsg}</ErrorMsg>}
    </InputAndErrorWrapper>
  );
});

export default ValidationInput;
